import { http, HttpResponse } from 'msw';

export default {
    quilttSessionToken: http.post('*/quiltt/session-token/', () =>
        HttpResponse.json({
            token: 'mock-token',
            userId: 'user_1',
            userUuid: 'uuid-1',
            environmentId: 'env_1',
            expiration: 3600,
            expiresAt: '2099-01-01T00:00:00Z',
        })
    ),
    // Quiltt SDK sends telemetry/beacon events directly to api.quiltt.io
    quilttBeacon: http.post('https://api.quiltt.io/v1/sdk/beacon', () => HttpResponse.json(null, { status: 200 })),
};
